export const QA_NAME_LISTING_PROFILE_APPLICANTS_RETRY = 'listingApplicantsRetry'

export const QA_NAME_LISTING_PROFILE_APPLICANTS_TABLE = 'listingApplicants'

export const LISTING_PROFILE_APPLICANTS_SKELETON_ROWS = 5

export const LISTING_APPLICANTS_PAGE_SIZE = 20

export const LISTING_APPLICANT_ACTION_OPEN = 'open'

export const ListingApplicantColumnName = {
  Applicant: 'identity',
  Chips: 'match_chips',
  Fit: 'match',
  Portal: 'source',
  Received: 'received',
  Stage: 'stage',
  Viewing: 'viewing',
  WaitingOn: 'waiting_on',
}

export const LISTING_APPLICANT_COLUMNS_CONFIG = {
  [ListingApplicantColumnName.Applicant]: {
    index: 0,
    name: ListingApplicantColumnName.Applicant,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsApplicantColumnKey',
    visible: true,
    width: 260,
  },
  [ListingApplicantColumnName.Chips]: {
    index: 3,
    name: ListingApplicantColumnName.Chips,
    ordering_field: null,
    title: 'RentalPortal.MatchColumnChipsKey',
    visible: true,
    width: 440,
  },
  [ListingApplicantColumnName.Fit]: {
    index: 2,
    name: ListingApplicantColumnName.Fit,
    ordering_field: null,
    title: 'RentalPortal.MatchColumnFitKey',
    visible: true,
    width: 320,
  },
  [ListingApplicantColumnName.Portal]: {
    index: 4,
    name: ListingApplicantColumnName.Portal,
    ordering_field: null,
    title: 'RentalPortal.ApplicantPortalColumnKey',
    visible: true,
    width: 200,
  },
  [ListingApplicantColumnName.Received]: {
    index: 5,
    name: ListingApplicantColumnName.Received,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsReceivedColumnKey',
    visible: true,
    width: 160,
  },
  [ListingApplicantColumnName.Stage]: {
    index: 1,
    name: ListingApplicantColumnName.Stage,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsStageColumnKey',
    visible: true,
    width: 160,
  },
  [ListingApplicantColumnName.Viewing]: {
    index: 7,
    name: ListingApplicantColumnName.Viewing,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsViewingColumnKey',
    visible: true,
    width: 180,
  },
  [ListingApplicantColumnName.WaitingOn]: {
    index: 6,
    name: ListingApplicantColumnName.WaitingOn,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileApplicantsWaitingOnColumnKey',
    visible: true,
    width: 160,
  },
}

export const LISTING_APPLICANT_STAGES = {
  approved: {
    text: 'RentalPortal.ApplicantStageApprovedKey',
    textColor: 'var(--color-success)',
  },
  pool: {
    text: 'RentalPortal.ApplicantStagePoolKey',
    textColor: 'var(--color-info)',
  },
  rejected: {
    text: 'RentalPortal.ApplicantStageRejectedKey',
    textColor: 'var(--color-error)',
  },
  screening: {
    text: 'RentalPortal.ApplicantStageScreeningKey',
    textColor: 'var(--color-warning)',
  },
  selected: {
    text: 'RentalPortal.ApplicantStageSelectedKey',
    textColor: 'var(--color-success)',
  },
  withdrawn: {
    text: 'RentalPortal.ApplicantStageWithdrawnKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const LISTING_APPLICANT_ROW_ACTIONS = [
  {
    label: 'RentalPortal.ListingProfileApplicantsOpenActionOptionKey',
    permission: true,
    value: LISTING_APPLICANT_ACTION_OPEN,
  },
]
